export default {
  "content": "<path d=\"M10.681 11.268a1.001 1.001 0 010 1.464l-7 6.5-1.361-1.464L8.53 12 2.32 6.232 3.68 4.767l7 6.5zM22.5 18H12v-2h10.5v2z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};